import React from "react"
import * as S from './Panel.styles';

function Panel() {
    return (
        <S.Cont>
        </S.Cont>
    )
}

export default Panel